import { combineReducers } from '@reduxjs/toolkit'
import gameSetting from './slices/gameSettings.slice'
import crashGame from './slices/crashGame.slice'
import authSlice from './slices/auth.slice'
import chat from './slices/chat.slice'
import aztecManGame from './slices/aztecManGame.slice'
import followTheArrowGame from './slices/followTheArrowGame.slice'
import powerOfThorGame from './slices/powerOfThorGame.slice'
import happyBirdsGame from './slices/happyBirdsGame.slice'
import galaxyGrabGame from './slices/galaxyGrabGame.slice'
import blackjackGame from './slices/blackjackGame.slice'
import mineGame from './slices/mineGame.slice'
import plinkoGame from './slices/plinkoGame.slice'
import rouletteGame from './slices/rouletteGame.slice'

const rootReducer = combineReducers({
  gameSetting,
  crashGame,
  aztecManGame,
  followTheArrowGame,
  powerOfThorGame,
  happyBirdsGame,
  galaxyGrabGame,
  auth: authSlice,
  chat,
  blackjackGame,
  mineGame,
  plinkoGame,
  rouletteGame
})

export default rootReducer
